<template>
  <!-- companies table -->
  <CompaniesTable :companies="companies"></CompaniesTable>
</template>

<script>
import CompaniesTable from "@/components/tables/CompaniesTable";

export default {
  name: "Companies",
  components: {CompaniesTable},
  computed: {
    companies() {
      return this.$store.getters.companies;
    }
  },
  mounted() {
    this.$store.dispatch('fetchCompanies');
  }
}
</script>

<style scoped>

</style>
